import { useEffect, useState } from "react";
import api from "@/lib/api";

// 8.2 owner-only: AccentCoach aggregates (no transcripts, no learner identities) — does a bank need to grow?
export const AccentUsageReport = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/usage/accent").then((r) => setD(r.data)).catch(() => setD({ languages: [] })); }, []);
  if (!d) return null;
  return (
    <div className="nb-card p-5 mt-6" data-testid="accent-usage-report">
      <h2 className="font-cabinet font-extrabold text-xl">AccentCoach usage</h2>
      <p className="text-xs text-gray-500 mb-3">{d.expansion_rule}</p>
      {d.languages.length === 0 && <p className="text-sm text-gray-500" data-testid="accent-usage-empty">No AccentCoach attempts yet.</p>}
      <div className="overflow-x-auto">
        <table className="text-sm w-full">
          <thead><tr className="text-left text-xs uppercase text-gray-500">
            <th className="pr-3">Lang</th><th className="pr-3">Attempts</th><th className="pr-3">Learners</th><th className="pr-3">Per learner</th>
            <th className="pr-3">Phrases</th><th className="pr-3">Bank reached</th><th className="pr-3">Repeat</th><th className="pr-3">Acc / Flu / Comp</th>
            <th className="pr-3">Weak sounds</th><th>Exhaustion</th></tr></thead>
          <tbody>
            {d.languages.map((l) => (
              <tr key={l.language} className="border-t border-gray-200" data-testid={`accent-usage-row-${l.language}`}>
                <td className="pr-3 font-bold">{l.language}</td><td className="pr-3">{l.attempts}</td><td className="pr-3">{l.learners}</td>
                <td className="pr-3">{l.attempts_per_learner}</td><td className="pr-3">{l.unique_phrases}/{l.bank_size}</td>
                <td className="pr-3">{l.bank_reached_pct ?? "—"}% (max learner {l.max_learner_bank_reached_pct}%)</td>
                <td className="pr-3">{l.repeat_factor}×{l.often_repeated.length ? ` · ${l.often_repeated.length} hot` : ""}</td>
                <td className="pr-3">{["accuracy", "fluency", "completeness"].map((k) => l.avg_scores[k] ?? "—").join(" / ")}</td>
                <td className="pr-3 text-xs">{l.weak_focus.map(([f, n]) => `${f} (${n})`).join(", ") || "—"}</td>
                <td className={l.exhaustion_risk ? "text-coral font-bold" : ""}>{l.exhaustion_risk ? "Grow bank" : "OK"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
